import $ from 'jquery';

import Nav from './views/nav';
import Accordion from './views/accordion';
import PageNav from './views/pagenav';
import Header from './views/header';
import HeroVideo from './views/hero-video';
import Video from './views/video';
import ScrollIntoView from './views/scrolled-into-view';
import DetectBrowser from './views/detect-browser';
import EmbedMessage, { bindConsentListeners } from './views/embed-message';
import initEventFilters from './views/event-filters';

$(document).ready(() => {
    const $embedMessage = $('.js-embed-message');
    if ($embedMessage.length) {
        $embedMessage.each((i, v) => EmbedMessage(v));
    }

    bindConsentListeners();
});

new DetectBrowser(); 

if (document.querySelector('.js-nav')) {
    new Nav();
}

if (document.querySelector('.js-accordion-trigger')) {
    new Accordion();
}

if (document.querySelector('.js-page-nav')) {
    new PageNav();
}

if (document.querySelector('.js-hero-video')) {
    new HeroVideo();
}

if (document.querySelector('.js-play')) {
    new Video({trigger: '.js-play'});
}

if (document.querySelector('.js-header')) {
    new Header();
}

if (document.querySelector('.blurbs__quote')) {
    new ScrollIntoView({ trigger: '.blurbs__quote', offset: 200 });
}

if (document.querySelector('.quote')) {
    new ScrollIntoView({ trigger: '.quote', offset: 100 });
}

if (document.querySelector('.event-filters')) {
    initEventFilters();
}
